/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import LeadsService from '@/services/LeadsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Leads/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

// flowId and background only tag the request, so the slice knows which
// flow answered and whether to show the skeleton.
export const getLeads = createAsyncThunk('Leads/getLeads', ({ query }) =>
  LeadsService.getLeads(query)
);

export const loadMoreLeads = handler(
  'loadMoreLeads',
  LeadsService.loadMoreLeads
);

export const setLeadComment = handler(
  'setLeadComment',
  LeadsService.setLeadComment
);

// currentUserId stays in the action so the slice can admit a pool card.
// The status endpoint does not accept it.
export const setMassLeadStatus = createAsyncThunk(
  'Leads/setMassLeadStatus',
  (arg) => {
    const data = { ...arg };
    delete data.currentUserId;
    return LeadsService.setLeadStatus(data);
  }
);

export const getLeadsStatus = handler(
  'getLeadsStatus',
  LeadsService.getLeadsStatus
);

export const getAgentsForLeads = handler(
  'getAgentsForLeads',
  LeadsService.getAgentsForLeads
);

export const getLeadsTags = handler('getLeadsTags', LeadsService.getLeadsTags);

export const getClosingExcuses = handler(
  'getClosingExcuses',
  LeadsService.getClosingExcuses
);

export const closeLeads = handler('closeLeads', LeadsService.closeLeads);
